module.exports = __webpack_public_path__ + "static/03-23286840236140b3052a5732240dd928.jpg";